import type { RouteRecordRaw } from 'vue-router'

const productRoutes: RouteRecordRaw[] = [
  {
    path: 'products',
    component: () => import('@/pages/products/layout.vue'),
    meta: { title: '商品管理', requiresPsi: true },
    children: [
      {
        path: '',
        name: 'Products',
        component: () => import('@/pages/products/index.vue'),
        meta: { title: '商品资料' },
      },
      {
        path: 'categories',
        name: 'ProductCategories',
        component: () => import('@/pages/products/categories.vue'),
        meta: { title: '商品分类' },
      },
      {
        path: 'suppliers',
        name: 'ProductSuppliers',
        component: () => import('@/pages/products/suppliers.vue'),
        meta: { title: '商品供应商管理' },
      },
      {
        path: 'purchase-orders',
        name: 'PurchaseOrders',
        component: () => import('@/pages/purchase-orders/index.vue'),
        meta: { title: '采购单' },
      },
    ],
  },
]

export default productRoutes
